<template>
  <div class="con-vs-alert my-3 con-vs-alert-primary" v-if="dataConsolidado">
    <h4 class="titlex vs-alert--title">Consolidado</h4>
    <div class="vs-alert">
      <span>Quantidade de Veiculos: {{ dataConsolidado.veiculos }}</span>
      <span> Quantidade de Beneficiários: {{ dataConsolidado.associados }}</span>
      <span> Quantidade de Cobranças: {{ dataConsolidado.boletos }}</span>
      <span> Valor Total Rateio: {{ dataConsolidado.total | currency }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataConsolidado'],
};
</script>

<style scoped lang="scss">
span {
  display: block;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
}
</style>
